import {useEffect, useRef} from 'react';
import {useReservation} from 'context/reservation';
import {useChekinSDK} from 'context/ChekinSDK';
import {AUTH_INIT_MODELS} from '@chekin/core';
import {useIdleDetector} from 'components/sessions/useIdleDetector';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {hasSession, removeExpiredSessions} from 'components/sessions/utils';
import {
  SessionCloseModal,
  type SessionCloseModalRef,
} from 'components/sessions/SessionCloseModal/SessionCloseModal';

export const ExpireSessionCloseModal = () => {
  const {reservationId} = useReservation();
  const {modelName} = useChekinSDK();
  const modalRef = useRef<SessionCloseModalRef>(null);
  const layoutMode = useLayoutMode();
  const enabled =
    hasSession(reservationId) &&
    modelName !== AUTH_INIT_MODELS.housing &&
    layoutMode === 'default';

  useEffect(() => {
    removeExpiredSessions();
  }, []);

  useIdleDetector({
    enabled,
    onIdle: () => modalRef.current?.open(),
  });

  return (
    reservationId && <SessionCloseModal ref={modalRef} reservationId={reservationId} />
  );
};
